/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down-old': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M31.3 8.8c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-15 15c-.4.4-1 .4-1.4 0l-15-15c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L17 23.1 31.3 8.8z"/>'
  }
})
